import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations, type Dictionary, type Language } from '../data/translations';
type LanguageContextValue = {
  lang: Language;
  setLang: (lang: Language) => void;
  t: Dictionary;
};
const LanguageContext = createContext<LanguageContextValue | null>(null);
export function LanguageProvider({
  children,
  initialLang = 'es'
}: {
  children: React.ReactNode;
  initialLang?: Language;
}) {
  const [lang, setLang] = useState<Language>(initialLang);
  useEffect(() => {
    setLang(initialLang);
  }, [initialLang]);
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t: translations[lang]
  }} data-id="element-282" data-mp="1392x3qcjt7w4">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}